import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Messaging } from 'src/app/core/models/messaging.model';
import { User, UserCommunications, UserMessaging } from 'src/app/core/models/user';
import { MessagingService } from 'src/app/core/services/messaging.service';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { ChangeEvent } from '@ckeditor/ckeditor5-angular';
import { AppConstants } from 'src/app/app.constants';
import { Functions, httpsCallableData } from '@angular/fire/functions';
import { em } from '@fullcalendar/core/internal-common';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-user-communications',
  templateUrl: './user-communications.component.html',
  styleUrls: ['./user-communications.component.scss']
})
export class UserCommunicationsComponent implements OnInit, OnChanges {

  @Input()
  user: User;
  @Input()
  cancel: EventEmitter<boolean>;
  @Output()
  messagingChanged: EventEmitter<UserMessaging> = new EventEmitter();

  userCommunications: UserCommunications;
  messaging: any;
  selected: Messaging;
  template = '';
  public Editor = ClassicEditor;
  edtRef: any;
  msgChanged = false;
  selectedType: string;
  noIntro = false;
  noUpsell = false;
  isFirstLoad = true;
  selectedTemplateChanged = false;

  constructor(private messagingService: MessagingService, private fns: Functions, private toastr: ToastrService) { }

  ngOnChanges(changes: SimpleChanges): void {
    console.log(changes)
    this.user = changes['user'].currentValue;
    const found = this.user.userMessaging?.filter(ele => ele.notSaved != undefined && ele.notSaved);
    if (found?.length == 0) {
      this.templateSelected(undefined);
    }
  }

  ngOnInit() {
    this.setupPage();
  }

  async setupPage() {
    this.userCommunications = this.user.userCommunications ?? new UserCommunications(true, true, false, false, true, true);
    this.messagingService.getAllMessaging().subscribe(data => {
      this.messaging = data;
      this.selected = this.messaging[0];
      this.selectedType = this.selected.type;
      this.template = this.selected.templates[0];
      const hasIntro = (this.user.userMessaging ?? []).filter(ele => ele.type == AppConstants.INSTRUCTOR_INTRO_EMAIL);
      if (hasIntro?.length == 0) {
        this.noIntro = true;
        const msg = new UserMessaging(this.selected.type, this.template);
        msg.notSaved = true;
        this.messagingChanged.emit(msg);
      } else {
        this.noIntro = false;
      }
    });
    this.cancel.subscribe(ev => {
      this.edtRef.data.set(this.template);
    })
  }

  templateSelected(e) {
    this.messagingChanged.emit(null);
    this.selectedTemplateChanged = true;
    this.template = this.selected?.templates[0];
    this.msgChanged = false;
    if (this.selected?.type == AppConstants.INSTRUCTOR_INTRO_EMAIL) {
      this.noUpsell = false;
      const hasIntro = this.user.userMessaging?.filter(ele => ele.type == AppConstants.INSTRUCTOR_INTRO_EMAIL);
      if (hasIntro?.length == 0) {
        this.noIntro = true;
      } else {
        this.noIntro = false;
      }
    } else if (this.selected?.type == AppConstants.INSTRUCTOR_MAKRETING_EMAIL) {
      this.noIntro = false;
      const hasMarketing = this.user.userMessaging?.filter(ele => ele.type == AppConstants.INSTRUCTOR_MAKRETING_EMAIL);
      if (hasMarketing?.length == 0) {
        this.noUpsell = true;
      } else {
        this.noUpsell = false;
      }
    }
  }

  sendTestEmail() {
    if (this.user.userMessaging && this.user.userMessaging.length > 0) {
      const email = this.user.userMessaging.find(ele => ele.type == this.selected.type);
      if (email && email.message?.length > 0) {
        const callable = httpsCallableData(this.fns, 'notifications-sendTestInstructorEmail');
        const nameOfInstructor = `${this.user.firstName} ${this.user.lastName}`;
        callable({ userId: this.user.userId, emailTemplate: email.message, nameOfInstructor: nameOfInstructor }).subscribe(d => { });
      } else {
        this.toastr.error('Please first save the email message for the selected email type');
      }
    } else {
      this.toastr.error('Please first save the email message for the selected email type');
    }
  }

  public onChange({ editor }: ChangeEvent) {
    if (!this.edtRef) {
      this.edtRef = editor;
    }
    const data = editor.data.get()
    if (data != this.template && !this.isFirstLoad && !this.selectedTemplateChanged) {
      this.updateCommunications(data);
      this.msgChanged = true;
    } else {
      this.msgChanged = false;
      this.isFirstLoad = false;
      this.selectedTemplateChanged = false;
    }
  }

  updateCommunications(data) {
    let messaging: UserMessaging;
    switch (this.selected.type) {
      case AppConstants.INSTRUCTOR_INTRO_EMAIL:
        messaging = new UserMessaging(AppConstants.INSTRUCTOR_INTRO_EMAIL, data);
        this.messagingChanged.emit(messaging);
        break;
      case AppConstants.INSTRUCTOR_MAKRETING_EMAIL:
        messaging = new UserMessaging(AppConstants.INSTRUCTOR_MAKRETING_EMAIL, data);
        this.messagingChanged.emit(messaging);
        break;

    }
  }

  resetMessagingValues() {
    this.edtRef.data.set(this.template);
  }

}
